import React from 'react';
import { Container, Row, Stack } from 'react-bootstrap';
import { getAssessmentContentBlank } from '../shared/report-util';
import { REPORT_TYPE } from '../../../utils/constants';

export const recruiterBreakpoints = {
  breaks: [5, 4],
  scale: 5,
};

function CandidateRecruiterProfile({ candidate }) {
  return (
    <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
      {candidate && (
        <>
          <Container className="candidate-profile-assessment-content">
            <Row className="w-50 justify-content-left">
              <h3 className="pt-4 pb-1">RECRUITING PROFILE</h3>
            </Row>
            <Row className="w-100 pb-2">
              <div className="pt-4">
                The following items give you an idea of the various elements of the work environment (organizational,
                management and job) that the candidate would find appealing in order to help in their placement in the
                right organization.
              </div>
            </Row>
            <Row>
              <div className="pt-3 text-bold">Interpreting your scores:</div>
              <div>
                Scores are color-coded to easily see where the candidate has very strong, medium or limited preferences
              </div>
              <Row className="w-100 mx-auto justify-content-center pt-2 pb-3 ps-5">
                <Stack direction="horizontal">
                  <div className="w-25">{getAssessmentContentBlank('', 4.25, undefined, REPORT_TYPE.staffing)}</div>
                  <div className="w-75">
                    Dark blue bars represent a High score on an assessment (e.g., 65th to 99th % tile).
                  </div>
                </Stack>
                <Stack direction="horizontal">
                  <div className="w-25">{getAssessmentContentBlank('', 3, undefined, REPORT_TYPE.staffing)}</div>
                  <div className="w-75">
                    Teal blue bars represent an Average score on an assessment (e.g., 36th to 64th % tile).
                  </div>
                </Stack>
                <Stack direction="horizontal">
                  <div className="w-25">{getAssessmentContentBlank('', 2, undefined, REPORT_TYPE.staffing)}</div>
                  <div className="w-75">
                    Sky blue bars represent a Low score on an assessment (e.g., 1st to 35th % tile).
                  </div>
                </Stack>
              </Row>
            </Row>
            <div className="text-bold" style={{ color: '#0770a9' }}>
              Organization
            </div>
            <Row className="w-100 mx-auto justify-content-center">
              <div className="ps-5">
                <Stack direction="horizontal">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      undefined,
                      candidate.values.codes['Compet'],
                      recruiterBreakpoints,
                      REPORT_TYPE.staffing
                    )}
                  </div>
                  <div className="w-75">Prefers a Competitive/Metric-Driven Environment</div>
                </Stack>
                <Stack direction="horizontal">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      undefined,
                      candidate.values.codes['C_Inv2'],
                      recruiterBreakpoints,
                      REPORT_TYPE.staffing
                    )}
                  </div>
                  <div className="w-75">Organization is respected in the community</div>
                </Stack>
                <Stack direction="horizontal">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      undefined,
                      candidate.values.codes['Miss'],
                      recruiterBreakpoints,
                      REPORT_TYPE.staffing
                    )}
                  </div>
                  <div className="w-75">Places a premium on working for a Mission-focused Organization</div>
                </Stack>
              </div>
            </Row>
            <div className="text-bold pt-3" style={{ color: '#0770a9' }}>
              Role
            </div>
            <Row className="w-100 mx-auto justify-content-center">
              <div className="ps-5">
                <Stack direction="horizontal">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      undefined,
                      candidate.experience.codes['Remote2'],
                      recruiterBreakpoints,
                      REPORT_TYPE.staffing
                    )}
                  </div>
                  <div className="w-75">Prefers a fully remote role</div>
                </Stack>
                <Stack direction="horizontal">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      undefined,
                      candidate.experience.codes['Remote1'],
                      recruiterBreakpoints,
                      REPORT_TYPE.staffing
                    )}
                  </div>
                  <div className="w-75">Prefers an onsite role</div>
                </Stack>
                <Stack direction="horizontal">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      undefined,
                      candidate.experience.codes['Remote3'],
                      recruiterBreakpoints,
                      REPORT_TYPE.staffing
                    )}
                  </div>
                  <div className="w-75">Prefers a hybrid (remote/onsite) role</div>
                </Stack>
                <Stack direction="horizontal">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      undefined,
                      candidate.values.codes['Struct'],
                      recruiterBreakpoints,
                      REPORT_TYPE.staffing
                    )}
                  </div>
                  <div className="w-75">Needs a highly structured job/role</div>
                </Stack>
                <Stack direction="horizontal">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      undefined,
                      candidate.experience.codes['Partner5'],
                      recruiterBreakpoints,
                      REPORT_TYPE.staffing
                    )}
                  </div>
                  <div className="w-75">Easily builds strong relationships</div>
                </Stack>
              </div>
            </Row>
            <div className="text-bold pt-3" style={{ color: '#0770a9' }}>
              Manager
            </div>
            <Row className="w-100 mx-auto justify-content-center">
              <div className="ps-5">
                <Stack direction="horizontal">
                  <div className="w-25">
                    {getAssessmentContentBlank(undefined, candidate.values.codes['DecAut'], recruiterBreakpoints, true)}
                  </div>
                  <div className="w-75">Thrives when given decision making authority by their manager</div>
                </Stack>
                <Stack direction="horizontal">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      undefined,
                      candidate.values.codes['Meaning'],
                      recruiterBreakpoints,
                      REPORT_TYPE.staffing
                    )}
                  </div>
                  <div className="w-75">Prefers a manager who believes their work is meaningful</div>
                </Stack>
                <Stack direction="horizontal">
                  <div className="w-25">
                    {getAssessmentContentBlank(
                      undefined,
                      candidate.values.codes['Recog'],
                      recruiterBreakpoints,
                      REPORT_TYPE.staffing
                    )}
                  </div>
                  <div className="w-75">Appreciates rewards/recognition from their manager</div>
                </Stack>
              </div>
            </Row>
          </Container>
        </>
      )}
    </Container>
  );
}

export default CandidateRecruiterProfile;
